import config from '../config/config'
import { BgmExtension, BgmTrack } from '../enums/enums'

export function getBgmUrl (trackName: string): string {
  const courseFilesUrl = config.loadEnvironmentVariables().courseFilesUrl
  const baseBgmUrl = `${courseFilesUrl}audio/bgm`
  const extension = getBgmExtension(trackName)

  const url = `${baseBgmUrl}/${trackName}${extension}`

  return url
}

export function getSfxUrl (sfxName: string): string {
  const courseFilesUrl = config.loadEnvironmentVariables().courseFilesUrl
  return `${courseFilesUrl}audio/sfx/${sfxName}.wav`
}

export function getBgmExtension (trackName: string): string {
  switch (trackName) {
    case BgmTrack.None: return BgmExtension.None

    case BgmTrack.Dashboard: return BgmExtension.Dashboard
    case BgmTrack.Completed: return BgmExtension.Completed

    case BgmTrack.Cocaine : return BgmExtension.Cocaine
    case BgmTrack.Xanax : return BgmExtension.Xanax
    case BgmTrack.Mdma : return BgmExtension.Mdma
    case BgmTrack.Response : return BgmExtension.Response
    case BgmTrack.Lightning : return BgmExtension.Lightning

    default: return BgmExtension.None
  }
}
